import styled from '@emotion/styled'

export const EmailWrapper = styled.div`
  margin: 20px 0;
`

export const LinkWrapper = styled.div`
  margin: 25px 0 0 10px;
`
